import ANYTIME from '../constants/timeDropdownConstants';
import { END_TIME } from '../constants/dateConstants';

export const isValidTime = ({
  startDate, endDate, startTime, value, stateKey,
}) => {
  if (startDate && endDate && value && startDate === endDate
    && value !== ANYTIME) {
    if (startTime && stateKey === END_TIME && startTime !== ANYTIME) {
      return value >= startTime;
    }
  }
  return true;
};

export const getTimeLabels = (isEnabledNewTimeLabel) => ({
  timeAriaLabelForDeparture: isEnabledNewTimeLabel ? 'aria.departure_time.new' : 'aria.departure_time',
  timeAriaLabelForArrival: isEnabledNewTimeLabel ? 'aria.arrival_time.new' : 'aria.arrival_time',
});

export const padString = (value) => value.toString().padStart(2, '0');

export const getTimeValue = (hour, minutes) => `${padString(hour)}:${padString(minutes)}`;

export const getHour24Format = (hour, minutes) => {
  const timeLabel = `${padString(hour)}:${padString(minutes)}`;
  return {
    label: timeLabel,
    value: getTimeValue(hour, minutes),
    formatted: timeLabel,
  };
};

const getHourAmPmFormat = (hour, minutes) => {
  const timeLabel = `${hour % 12 === 0 ? '12' : hour % 12}:${padString(minutes)}`;
  const meridiem = hour >= 12 ? 'PM' : 'AM';
  return {
    label: `${timeLabel} ${meridiem}`,
    value: getTimeValue(hour, minutes),
    formatted: timeLabel,
    period: meridiem,
  };
};

const isFutureTime = (hour, minutes) => {
  const now = new Date();
  return now.getHours() < hour || (now.getHours() === hour && now.getMinutes() < minutes);
};

export const getHourLabels = (anytimeLabel, {
  is24Hour,
  minutesIntervalPerOption,
  hasAnytime,
  showPastHoursOfDay,
  startTime,
}) => {
  let startHour = 0; let
    startMinute = 0;
  if (startTime) {
    const [hour, minute] = startTime.split(':').map(Number);
    startHour = hour;
    startMinute = minute;
  }

  const hours = [];
  for (let hour = startHour; hour < 24; hour += 1) {
    for (let minutes = startMinute; minutes < 60; minutes += minutesIntervalPerOption) {
      if (showPastHoursOfDay || isFutureTime(hour, minutes)) {
        if (is24Hour) {
          hours.push(getHour24Format(hour, minutes));
        } else {
          hours.push(getHourAmPmFormat(hour, minutes));
        }
      }
    }
  }

  if (hasAnytime) {
    hours.unshift({
      value: ANYTIME,
      label: anytimeLabel,
    });
  }
  return hours;
};
